const { delegateEvent } = require('../utilities/javascriptUtils');

/**
 * Handle Equivalences title and tabs visibility
 * @param {Element} equivalenceLink equivalences Link
 */
function handleEquivalencesVisibility(equivalenceLink) {
    var isLinkCustomActivated = equivalenceLink?.classList.contains('custom-active');
    var restOfLinks = document.querySelectorAll('.size-chart .nav-link:not(.equivalences-link)');
    var equivalencesTitle = document.querySelector('.equivalences-title');

    if (isLinkCustomActivated) {
        equivalencesTitle?.classList.add('d-none');
        restOfLinks?.forEach((link)=>{
            link.style.opacity = 1; // eslint-disable-line no-param-reassign
        });

        // Activate firts link and tab
        restOfLinks[0]?.classList.add('active');
        document.querySelector('.size-chart .tab-pane')?.classList.add('active');

        // Deactivate Equivalences link and tab
        equivalenceLink?.classList.remove('active');
        document.getElementById('equivalences')?.classList.remove('active');
        equivalenceLink?.classList.remove('custom-active');
    } else {
        restOfLinks?.forEach((link)=>{
            link.style.opacity = 0; // eslint-disable-line no-param-reassign
        });
        equivalencesTitle?.classList.remove('d-none');
        equivalenceLink?.classList.add('custom-active');
    }
}

/**
 * Reset all links to initial state (First tab active)
 */
function resetLinks() {
    var tabLinks = document.querySelectorAll('.size-chart .nav-link:not(.equivalences-link)');
    var equivalencesTitle = document.querySelector('.equivalences-title');
    var equivalenceLink = document.querySelector('.equivalences-link');

    tabLinks?.forEach((link)=>{
        link.style.opacity = 1; // eslint-disable-line no-param-reassign
    });

    tabLinks[0]?.classList.add('active');

    equivalencesTitle?.classList.add('d-none');
    equivalenceLink?.classList.remove('active', 'custom-active');
}

/**
 * Delegate Event for Equivalences link
 */
function initEquivalencesLinkEvent() {
    delegateEvent('click', '.equivalences-item', function (event) {
        var equivalenceLink = event.target.closest('.nav-link');
        handleEquivalencesVisibility(equivalenceLink);
    });
}

module.exports = {
    init: function () {
        initEquivalencesLinkEvent();
    },
    methods: {
        resetLinks: resetLinks
    }
};
